var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
export var arrow = {
    alignContent: 'center',
    color: 'transparent',
    display: 'block',
    width: 12,
    height: 12,
    position: 'absolute',
    zIndex: parseInt('700') + 1,
    background: '#ffffff',
    borderRightColor: 'transparent',
    borderBottomColor: 'transparent',
    margin: 0,
};
export var arrowTop = __assign(__assign({}, arrow), { bottom: -6, clipPath: 'polygon(0 0, 100% 0, 0 100%, 0 100%);', transform: 'rotate(225deg)' });
export var arrowBottom = __assign(__assign({}, arrow), { top: -6, clipPath: 'polygon(0 0, 100% 0, 0 100%, 0 100%);', transform: 'rotate(45deg)' });
export var arrowLeftRight = {
    background: '#ffffff',
    borderRightColor: 'transparent',
    borderBottomColor: 'transparent',
    clipPath: 'polygon(0 0, 100% 0, 0 100%, 0 100%);',
    height: 12,
    marginLeft: 0,
    marginRight: 0,
    width: 12,
    zIndex: parseInt('700') + 1,
};
export var arrowLeft = __assign(__assign({}, arrowLeftRight), { right: -6, transform: 'rotate(135deg)' });
export var arrowRight = __assign(__assign({}, arrowLeftRight), { left: -6, transform: 'rotate(-45deg)' });
export var flyout = __assign(__assign({}, reset), { background: '#ffffff', border: "1px solid ".concat('#dadada'), borderRadius: 4, boxShadow: '0 0 12px 0 rgba(0,0,0,.25)', boxSizing: 'border-box', fontSize: 14, lineHeight: 24 + 'px', minHeight: 44, maxWidth: 400, minWidth: 80, position: 'relative' });
export var wrapper = {
    width: 'max-content',
    zIndex: '700',
    position: 'absolute',
    '&[data-flyout-placement*="bottom"]': {
        '[data-arrow="true"]': __assign({}, arrowBottom),
    },
    '&[data-flyout-placement*="top"]': {
        '[data-arrow="true"]': __assign({}, arrowTop),
    },
    '&[data-flyout-placement*="left"]': {
        '[data-arrow="true"]': __assign({}, arrowLeft),
    },
    '&[data-flyout-placement*="right"]': {
        '[data-arrow="true"]': __assign({}, arrowRight),
    },
};
export var menu = {
    lineHeight: 16 + 'px',
    textDecoration: 'none',
    verticalAlign: 'middle',
    color: '#1588af',
    textAlign: 'left',
};
export var menuWithHeader = __assign({}, menu);
export var menuItem = {
    background: 'none',
    border: 'none',
    borderTop: '1px solid #cccccc',
    boxSizing: 'border-box',
    color: '#1588af',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'block !important',
    lineHeight: 16 + 'px',
    padding: 12,
    textAlign: 'left',
    textDecoration: 'none',
    verticalAlign: 'middle',
    width: '100%',
    ':active': {
        color: '#044766',
        backgroundColor: "".concat('#1588af', "25"),
    },
    ':first-child': {
        borderTop: 0,
    },
    ':hover': {
        backgroundColor: "".concat('#1588af', "15"),
        color: '#085a7e',
    },
    '[class*="icon"]': {
        display: 'inline-block',
        marginRight: 8,
        verticalAlign: 'middle',
    },
};
export var menuItemFocused = {
    color: '#085a7e',
    boxShadow: "inset 0px 0 0 2px ".concat('#1588af'),
};
export var menuItemDisabled = __assign(__assign({}, menuItem), { color: "".concat('#a6a6a6'), cursor: 'not-allowed', ':active': {
        color: '#a6a6a6',
    }, ':hover': {
        color: '#a6a6a6',
    } });
export var focusTrapInnerContainer = {
    outlineColor: '#085a7e',
};
export var header = {
    borderBottom: '1px solid #cccccc',
    display: 'flex',
    padding: "".concat(12, "px ").concat(16, "px ").concat(12, "px ").concat(16, "px"),
};
export var headerTextWrapper = {
    flexGrow: 1,
};
export var headerText = {
    alignItems: 'center',
    display: 'inline-flex',
    fontSize: 20,
    fontWeight: '300',
    lineHeight: 24 + 'px',
};
export var subHeaderText = {
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 14 + 'px',
};
export var headerButtonContainer = {
    marginTop: "-".concat(4, "px"),
};
export var headerIcon = {
    color: '#222222',
};
export var body = {
    padding: 16,
};
export var bodyMenu = __assign(__assign({}, body), { padding: 0 });
export var bodyWithClose = {
    padding: "".concat(16, "px 36px ").concat(16, "px ").concat(16, "px"),
};
export var bodyUtility = __assign(__assign({}, body), { backgroundColor: '#f5f5f5', maxHeight: 400, overflowY: 'auto' });
export var footer = {
    alignItems: 'center',
    borderTop: '1px solid #cccccc',
    display: 'flex',
    maxHeight: 48,
    minHeight: 32,
    lineHeight: 'unset',
    padding: "".concat(8, "px ").concat(16, "px ").concat(8, "px ").concat(16, "px"),
};
export var closeButton = {
    position: 'absolute',
    right: '10px',
    top: '10px',
    height: '24px',
    width: '24px',
};
export var docked = {
    '&[data-flyout-placement*="bottom"]': {
        paddingTop: '0 !important',
    },
    '&[data-flyout-placement*="bottom-start"]': {
        marginLeft: '0 !important',
        paddingTop: '0 !important',
    },
    '&[data-flyout-placement*="bottom-end"]': {
        marginLeft: '0 !important',
        paddingTop: '0 !important',
    },
    '&[data-flyout-placement*="top"]': {
        paddingBottom: '0 !important',
    },
    '&[data-flyout-placement*="top-start"]': {
        marginLeft: '0 !important',
        paddingBottom: '0 !important',
    },
    '&[data-flyout-placement*="top-end"]': {
        marginLeft: '0 !important',
        paddingBottom: '0 !important',
    },
    '&[data-flyout-placement*="left"]': {
        paddingRight: '0 !important',
    },
    '&[data-flyout-placement*="left-start"]': {
        marginTop: '0 !important',
        paddingRight: '0 !important',
    },
    '&[data-flyout-placement*="left-end"]': {
        marginBottom: '0 !important',
        paddingRight: '0 !important',
    },
    '&[data-flyout-placement*="right"]': {
        paddingLeft: '0 !important',
    },
    '&[data-flyout-placement*="right-start"]': {
        marginTop: '0 !important',
        paddingLeft: '0 !important',
    },
    '&[data-flyout-placement*="right-end"]': {
        marginBottom: '0 !important',
        paddingLeft: '0 !important',
    },
    '[data-arrow="true"]': {
        display: 'none',
    },
};
